import enterDataFormSettings from './enter-data-form-settings.json';

class EnterDataFormService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    $onInit() {
        this.unsavedData = null;
    }

    getFormSettings() {
        return enterDataFormSettings.includedSettings;
    }


    /***
     *  Automatically save the backed up this.unsavedData object (will maintain the committed/not-committed flag from
     *  the most recently saved entry).
     */
    autoSaveStats() {
        if (this.unsavedData) {
            this.saveStats(this.unsavedData);
        }
    }

    /***
     *  Periodically called to save a backup of the most recently entered stats data. The backup is then used by
     *  the autoSaveStats() function.
     *
     * @param data  a dictionary of saved stats data from the EnterDataFormController.
     */
    updateUnsavedData(data) {
        this.unsavedData = data;
    }

    /***
     * Saves stats data. If the save is successful, deactivates the previous stats data.
     *
     * @param savedData         an object representing a new Stats row that will be added to
     *                          the database.
     *
     * @returns {Promise}
     */
    saveStats(savedData) {
        return this.$http.post(`${this.appConfig.apiUrl}/stats/`, savedData);
    }


}

export default EnterDataFormService;


// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-form/enter-data-form-service.js